function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoAppsAssigned(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M209.741,56.559h-88.075v123.635h88.075c4.358,0,7.894-3.536,7.894-7.894v-107.857c0-4.357-3.536-7.894-7.894-7.894v.009Z",
    style: {
      fill: "#53666d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.582,56.559c-4.357,0-7.894,3.536-7.894,7.894v107.857c0,4.358,3.536,7.894,7.894,7.894h88.075V56.559H33.582Z",
    style: {
      fill: "#284049"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 31.749,
    y: 62.611,
    width: 179.833,
    height: 89.917,
    rx: 1.842,
    ry: 1.842,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.155,180.194h-13.833v12.969h-15.562v6.052h38.906v-9.51c-5.257,0-9.51-4.254-9.51-9.51Z",
    style: {
      fill: "#53666d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.707,193.163h-15.562v-12.969h-12.969c0,5.257-4.254,9.51-9.51,9.51v9.51h38.042v-6.052Z",
    style: {
      fill: "#284049"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "101.706 111.448 101.706 112.448 100.706 112.448",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.766,
    y1: 112.448,
    x2: 41.539,
    y2: 112.448,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.569 112.448 39.569 112.448 39.569 111.448",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.569,
    y1: 109.492,
    x2: 39.569,
    y2: 71.336,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.957 1.957",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "39.569 70.358 39.569 69.358 40.569 69.358",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.509,
    y1: 69.358,
    x2: 99.736,
    y2: 69.358,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "100.706 69.358 101.706 69.358 101.706 70.358",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.706,
    y1: 72.315,
    x2: 101.706,
    y2: 110.47,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.957 1.957",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "101.706 144.12 101.706 145.12 100.706 145.12",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 98.766,
    y1: 145.12,
    x2: 41.539,
    y2: 145.12,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "40.569 145.12 39.569 145.12 39.569 144.12",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.569,
    y1: 142.133,
    x2: 39.569,
    y2: 119.279,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.987 1.987",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "39.569 118.286 39.569 117.286 40.569 117.286",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 42.509,
    y1: 117.286,
    x2: 99.736,
    y2: 117.286,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "100.706 117.286 101.706 117.286 101.706 118.286",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.706,
    y1: 120.273,
    x2: 101.706,
    y2: 143.127,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.987 1.987",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "169.65 144.12 169.65 145.12 168.65 145.12",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 166.71,
    y1: 145.12,
    x2: 109.483,
    y2: 145.12,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "108.513 145.12 107.513 145.12 107.513 144.12",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.513,
    y1: 142.127,
    x2: 107.513,
    y2: 71.354,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.994 1.994",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "107.513 70.357 107.513 69.357 108.513 69.357",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 110.453,
    y1: 69.357,
    x2: 167.68,
    y2: 69.357,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.94 1.94",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "168.65 69.357 169.65 69.357 169.65 70.357",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 169.65,
    y1: 72.351,
    x2: 169.65,
    y2: 143.123,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.994 1.994",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    points: "205.582 144.12 205.582 145.12 204.582 145.12",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.644,
    y1: 145.12,
    x2: 176.482,
    y2: 145.12,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.938 1.938",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "175.513 145.12 174.513 145.12 174.513 144.12",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.513,
    y1: 142.087,
    x2: 174.513,
    y2: 102.442,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "2.033 2.033",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "174.513 101.425 174.513 100.425 175.513 100.425",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 177.451,
    y1: 100.425,
    x2: 203.613,
    y2: 100.425,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "1.938 1.938",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "204.582 100.425 205.582 100.425 205.582 101.425",
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.582,
    y1: 103.459,
    x2: 205.582,
    y2: 143.104,
    style: {
      fill: "none",
      stroke: "#e6e6e6",
      strokeDasharray: "2.033 2.033",
      strokeMiterlimit: 10,
      strokeWidth: ".5px"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 94.271,
    y: 53.145,
    width: 71.255,
    height: 52.182,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.532,106.333h-73.267v-54.194h73.267v54.194ZM95.276,104.321h69.244v-50.17h-69.244v50.17Z",
    style: {
      fill: "#29aae2"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 91.785,
    y: 50.659,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#29aae2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.04,
    y: 50.659,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#29aae2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 91.785,
    y: 102.841,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#29aae2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.04,
    y: 102.841,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#29aae2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.346,82.035c-.265-.788-.506-1.515-.755-2.239-.25-.726-.52-1.446-.756-2.177-.085-.264-.215-.365-.491-.364-3.146.005-6.292-.002-9.438.008-.137,0-.358.111-.398.221-.529,1.471-1.032,2.951-1.54,4.429-.008.023.005.052.019.168.332,0,.678-.017,1.022.003,1.595.094,2.76,1.286,2.769,2.821.009,1.569-1.222,2.858-2.798,2.869-2.7.02-5.401.019-8.101-.003-.543-.004-1.121-.047-1.619-.239-1.307-.504-1.934-1.794-1.669-3.23.22-1.192,1.374-2.162,2.657-2.221.377-.017.758-.031,1.134,0,.365.03.521-.127.632-.456.653-1.927,1.324-3.849,1.99-5.772,1.584-4.571,3.168-9.143,4.754-13.714.141-.407.262-.827.453-1.21.486-.978,1.266-1.592,2.383-1.611,1.971-.033,3.943-.039,5.913-.009,1.344.02,2.266.719,2.707,1.987,1.696,4.875,3.382,9.754,5.072,14.631.667,1.923,1.341,3.843,1.997,5.77.095.28.236.375.525.376.538.002,1.085-.003,1.614.081,1.464.233,2.404,1.502,2.3,3.04-.094,1.392-1.285,2.567-2.697,2.578-2.943.023-5.887.023-8.831,0-1.407-.011-2.595-1.194-2.683-2.592-.097-1.534.859-2.808,2.313-3.039.474-.075.96-.07,1.522-.107ZM118.68,71.544c-.031-.15-.042-.267-.079-.374-.593-1.705-1.186-3.409-1.787-5.111-.394-1.116-.4-1.099-1.583-1.084-.34.004-.469.15-.567.436-.613,1.784-1.239,3.563-1.856,5.345-.085.245-.145.498-.229.788h6.1Z",
    style: {
      fill: "#29b473"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.894,99.181c-7.075,0-14.149,0-21.224,0-2.43,0-4.861,0-7.291-.013-1.241-.007-2.242-.701-2.668-1.812-.711-1.856.597-3.824,2.59-3.857,1.714-.029,3.429-.016,5.144-.017,3.632-.002,7.264,0,10.896,0,6.953.002,13.907.008,20.86.008,6.211,0,12.422-.006,18.632-.007.594,0,1.189-.002,1.782.024,1.488.065,2.667,1.323,2.665,2.827-.002,1.507-1.173,2.792-2.67,2.816-2.619.043-5.238.028-7.858.031-3.537.004-7.075,0-10.612,0-3.416,0-6.832,0-10.248,0Z",
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.484,62.136c3.307,0,6.614-.006,9.921.003,1.364.004,2.549.951,2.793,2.196.372,1.894-.914,3.479-2.862,3.505-1.323.018-2.646.01-3.968.01-5.237-.001-10.475-.002-15.712-.008-1.429-.002-2.498-.732-2.898-1.96-.608-1.867.712-3.727,2.683-3.741,2.578-.019,5.156-.008,7.735-.009.769,0,1.539,0,2.308,0v.005Z",
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.502,77.024c3.294,0,6.588-.005,9.881.002,1.218.003,2.247.689,2.676,1.752.776,1.924-.575,3.916-2.7,3.948-1.566.024-3.132.011-4.698.011-5.008-.001-10.016-.004-15.024-.006-1.207,0-2.158-.479-2.721-1.566-.983-1.899.384-4.126,2.542-4.137,3.348-.017,6.695-.004,10.043-.005Z",
    style: {
      fill: "#f1ba1b"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 150.922,
    y: 74.029,
    width: 71.255,
    height: 52.182,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.183,127.217h-73.267v-54.194h73.267v54.194ZM151.928,125.206h69.244v-50.17h-69.244v50.17Z",
    style: {
      fill: "#d91c5c"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M198.069,95.149l-17.858,12.636-7.073-8.016-13.492,9.43v7.196c0,.711.576,1.287,1.287,1.287h51.235c.711,0,1.287-.576,1.287-1.287v-9.966l-15.385-11.28Z",
    style: {
      fill: "#8cc640"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.437,
    y: 71.544,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.692,
    y: 71.544,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.437,
    y: 123.726,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.692,
    y: 123.726,
    width: 4.971,
    height: 4.971,
    style: {
      fill: "#d91c5c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.167,118.486h-51.234c-1.153,0-2.091-.938-2.091-2.091v-32.549c0-1.153.938-2.092,2.091-2.092h51.234c1.153,0,2.092.938,2.092,2.092v32.549c0,1.153-.938,2.091-2.092,2.091ZM160.933,83.363c-.266,0-.482.216-.482.482v32.549c0,.266.216.482.482.482h51.234c.266,0,.482-.216.482-.482v-32.549c0-.266-.216-.482-.482-.482h-51.234Z",
    style: {
      fill: "#284049"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.484,
    cy: 90.884,
    r: 4.519,
    style: {
      fill: "#f1ba1b"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.211,91.748v-.876c0-1.425-1.154-2.587-2.587-2.587h-26.956c-1.425,0-2.587,1.154-2.587,2.587v46.616h64.244v-43.145c0-1.425-1.154-2.587-2.587-2.587h-29.536l.007-.007Z",
    style: {
      fill: "#ffdf4f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.939,
    y: 95.467,
    width: 59.142,
    height: 42.483,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M76.292,100.783l-.955,2.644h-27.669c-1.425,0-2.587,1.154-2.587,2.587v32.913c0,1.425,1.154,2.587,2.587,2.587h59.078c1.425,0,2.587-1.154,2.587-2.587v-37.267c0-1.425-1.154-2.587-2.587-2.587h-28.025c-1.09,0-2.059.684-2.43,1.71h0Z",
    style: {
      fill: "#ffcc01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.333,138.926v-21.455c-17.842,17.358-48.796,22.004-63.532,23.244.47.492,1.133.798,1.867.798h59.078c1.425,0,2.587-1.154,2.587-2.587Z",
    style: {
      fill: "#fcbd11"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.176,105.507h-21.847c-1.154,0-2.088.933-2.088,2.088v4.625c3.677-2.515,11.964-5.686,23.935-6.712Z",
    style: {
      fill: "#ffd715"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAppsAssigned);
export default __webpack_public_path__ + "static/media/NoAppsAssigned.50ec13c3608925c7937bbfab1d63e88e.svg";
export { ForwardRef as ReactComponent };